import type { AddedProtectionItem } from "services/cms/models";

import type { ResolvedAddedProtectionItemLinkResolver } from "./addedProtectionItemLinkResolver";
import addedProtectionItemLinkResolver from "./addedProtectionItemLinkResolver";
import type { ResolvedImage } from "./imageResolver";
import imageResolver from "./imageResolver";

export interface ResolvedAddedProtectionItem {
    description: string;
    id: string;
    image: ResolvedImage;
    link: ResolvedAddedProtectionItemLinkResolver;
    title: string;
}

const addedProtectionItemsResolver = (
    items: AddedProtectionItem[]
): ResolvedAddedProtectionItem[] => {
    return items.map((e: AddedProtectionItem) => {
        const image = imageResolver(e.elements.image.linkedItems[0]);
        const link = addedProtectionItemLinkResolver(e.elements.link.linkedItems[0]);
        const id = e.system.id;

        return {
            description: e.elements.description.value,
            id,
            image,
            link,
            title: e.elements.title.value,
        };
    });
};

export default addedProtectionItemsResolver;
